import { TabPelican } from './component';
import { Props } from './props';

export type PelicanTabProps = Props;

export * from './component';

export default TabPelican;
